module.exports = __webpack_public_path__ + "img/loesungen-fuer-jede-lebenslage_kachl_SEASONALSUPPORT.c369747a.png";